import { FC } from 'react';
import {
  Bars,
  Donut,
  HorizontalBars,
  HorizontalBarsStacked,
  HorizontalBarsStacked100,
  Line,
  Line2,
  Pie,
  PivotTable,
  RichText,
  ChartTile as StatusBar,
  Table,
  TrendTile,
  VerticalBarsStacked,
  VerticalBarsStacked100,
} from '@fabric-ui/icons/widgetTypes';
import { AllTypeWidgets, BarSubType, LineSubType, PieSubType, TableSubType, TextSubType, TileSubType } from '../../types';
import { VennSubType } from '../../types/VennWidget.types';

type WidgetType = AllTypeWidgets['type'];

// @ts-ignore
export const widgetTypeIconMap = {
  [BarSubType.BarHorizontal]: HorizontalBars,
  [BarSubType.BarVertical]: Bars,
  [BarSubType.Percentage100_Horizontal]: HorizontalBarsStacked100,
  [BarSubType.Percentage100_Vertical]: VerticalBarsStacked100,
  [BarSubType.StackedHorizontal]: HorizontalBarsStacked,
  [BarSubType.StackedVertical]: VerticalBarsStacked,
  [PieSubType.Donut]: Donut,
  [PieSubType.Pie]: Pie,
  [LineSubType.Line]: Line,
  [LineSubType.Spline]: Line2,
  [TableSubType.Table]: Table,
  [TableSubType.PivotTable]: PivotTable,
  [TileSubType.Tile]: StatusBar,
  [TileSubType.Trend]: TrendTile,
  [TextSubType.Text]: RichText,
} as Record<Exclude<WidgetType, TileSubType.Score | VennSubType | PieSubType.PieWithNeedle>, FC<React.SVGProps<SVGElement>>>;
